import React, { Component } from 'react';
import { Modal, Grid, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import { LabelsHelper } from '../../../helpers/LabelsHelper';

export class EventDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            event: props.event
        }
    }

    // -------------------

    renderAssociateToCalendarButton(event) {
        if ("unique" === event.type || "recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) {
            return <Button onClick={() => this.props.onAssociateToCalendar(event)}> ASSOCIAR A CALENDÁRIO </Button>
        }

        return null;
    }

    renderStopOnCalendarButton(event) {
        if (("recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) && event.hasDays) {
            return <Button onClick={() => this.props.onStopOnCalendar(event)}> INTERRONPER </Button>
        }

        return null;
    }

    renderEditButton(event) {
        if ("unique" === event.type || "recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) {
            return <Button onClick={() => this.props.onEdit(event)}> EDITAR </Button>
        }

        return null;
    }

    renderDeleteButton(event) {
        if ("unique" === event.type || "recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) {
            return <Button onClick={() => this.props.onDelete(event)}> ELIMINAR </Button>
        }

        return null;
    }

    renderUniqueEventProperties(event) {
        if ("unique" === event.type) {
            return (
                <div>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Data Início</Col>
                        <Col sm={8} md={9}>{event.beginDate}</Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Data Fim</Col>
                        <Col sm={8} md={9}>{event.endDate}</Col>
                    </Row>
                </div>
            );
        }

        return null;
    }

    renderRecurrentEventProperties(event) {
        if ("recurrent" === event.type || "recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) {
            const { dayTypes } = this.props;

            const conditionDayType = dayTypes.find(dayType => dayType.id === event.specialConditionDayType);
            const exceptionDayType = dayTypes.find(dayType => dayType.id === event.exceptionDayType);

            return (
                <div>
                    {this.renderWeeklyEventProperties(event)}
                    {this.renderMonthlyEventProperties(event)}
                    {this.renderYearlyEventProperties(event)}
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Nr. de Dias</Col>
                        <Col sm={8} md={9}>{event.nrConsecutiveDays}</Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Condição</Col>
                        <Col sm={8} md={9}>{undefined === conditionDayType ? "Sem Condição" : `${LabelsHelper.DaysOfWeek[event.specialConditionDayOfWeek]} [${conditionDayType.name}]`}</Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Exceção</Col>
                        <Col sm={8} md={9}>{undefined === exceptionDayType ? "Sem Excepção" : exceptionDayType.name}</Col>
                    </Row>
                </div>
            );
        }

        return null;
    }

    renderWeeklyEventProperties(event) {
        if ("recurrent-weekly" === event.type) {
            return (
                <Row className="padding-top-7">
                    <Col sm={4} md={3} className="details-label">Dia da Semana</Col>
                    <Col sm={8} md={9}>{LabelsHelper.DaysOfWeek[event.dayOfWeek]}</Col>
                </Row>
            );
        }

        return null;
    }

    renderMonthlyEventProperties(event) {
        if ("recurrent-monthly" === event.type) {
            if (event.useDayOfMonth) {
                return (
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Dia do Mês</Col>
                        <Col sm={8} md={9}>{event.dayOfMonth}</Col>
                    </Row>
                )
            }
            else {
                return (
                    <div>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Dia da Semana</Col>
                            <Col sm={8} md={9}>{LabelsHelper.DaysOfWeek[event.dayOfWeek]}</Col>
                        </Row>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Semanas</Col>
                            <Col sm={8} md={9}>{event.weeks.sort().join(", ")}</Col>
                        </Row>
                    </div>
                );
            }
        }

        return null;
    }

    renderYearlyEventProperties(event) {
        if ("recurrent-yearly" === event.type) {
            return (
                <div>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Dia</Col>
                        <Col sm={8} md={9}>{event.day}</Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={4} md={3} className="details-label">Mês</Col>
                        <Col sm={8} md={9}>{LabelsHelper.Months[event.month]}</Col>
                    </Row>
                </div>
            );
        }

        return null;
    }

    render() {
        const { event } = this.state;

        if (undefined === event || null === event) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Detalhes - {event.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Tipo</Col>
                            <Col sm={8} md={9}>{LabelsHelper.EventTypes[event.type]}</Col>
                        </Row>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Nome</Col>
                            <Col sm={8} md={9}>{event.name}</Col>
                        </Row>
                        {this.renderUniqueEventProperties(event)}
                        {this.renderRecurrentEventProperties(event)}
                    </Grid>
                    <ButtonToolbar className="margin-top-15">
                        {this.renderAssociateToCalendarButton(event)}
                        {this.renderStopOnCalendarButton(event)}
                        {this.renderEditButton(event)}
                        {this.renderDeleteButton(event)}
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
